import { Bell, Pin } from "lucide-react";
import { initialsOf } from "@/components/common/UserInitials";
import * as HoverCardPrimitive from "@radix-ui/react-hover-card";
import { Link } from "react-router-dom";
import { HoverCard, HoverCardTrigger, HoverCardContent } from "@/components/ui/hover-card";
import { AvatarBlock } from "@/components/settings/AccountSection";

export const RELANCE_COLOR = "#E0569B";

export const fmtAlger = (iso) => {
  if (!iso) return "—";
  try { return new Intl.DateTimeFormat("fr-FR", { timeZone: "Africa/Algiers", day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }).format(new Date(iso)).replace(",", ""); } catch { return String(iso).slice(0, 16); }
};

const fullName = (u) => `${u?.first_name || ""} ${u?.last_name || ""}`.trim();
// iter436 pt 2 — initiales : source unique (initialsOf)

/** iter410 L2-6 (P3) — cloche + bulle SOUS la cloche (330 px, flèche, premier plan) : dernière relance, lu/non lu, message complet, pied. */
export default function RelanceBell({ task, usersById = {} }) {
  const r = task.relances;
  if (!r || !r.count) return null;
  const color = r.unread ? "#F9A826" : "#6B6B73";
  const last = r.items[0];
  const unread = (last?.recipients || []).some((x) => !x.read_at);
  const author = usersById[last?.by] || { id: last?.by, first_name: last?.by_name || "—", last_name: "" };
  const prev = r.count - 1;
  return (
    <HoverCard openDelay={150} closeDelay={80}>
      <HoverCardTrigger asChild>
        <span className="inline-flex items-center" style={{ gap: 4, cursor: "default" }} data-testid={`row-relance-${task.id}`} data-unread={r.unread ? "1" : "0"}>
          <span className="relative inline-flex items-center" style={{ gap: 2, color }}>
            <Bell size={18} />
            {r.unread && <span style={{ position: "absolute", top: -1, left: 11, width: 6, height: 6, borderRadius: 999, background: "#EF4444" }} data-testid={`row-relance-dot-${task.id}`} />}
            <span className="tabular-nums" style={{ fontSize: 12, fontWeight: 500 }} data-testid={`row-relance-count-${task.id}`}>{r.count}</span>
          </span>
          {task.relance_active && <Pin size={14} style={{ color: RELANCE_COLOR, transform: "rotate(30deg)" }} data-testid={`row-relance-pin-${task.id}`} />}
        </span>
      </HoverCardTrigger>
      <HoverCardContent side="bottom" align="start" sideOffset={8} collisionPadding={8} className="z-[1500]"
        style={{ width: 330, background: "#1A1A1E", border: "1px solid #2E2E33", borderRadius: 10, padding: 10, boxShadow: "0 12px 32px rgba(0,0,0,.55)", whiteSpace: "normal" }}
        data-testid={`row-relance-pop-${task.id}`}>
        <HoverCardPrimitive.Arrow width={14} height={7} style={{ fill: "#1A1A1E", stroke: "#2E2E33" }} />
        <div className="flex items-center justify-between" style={{ gap: 8 }}>
          <span style={{ fontSize: 11.5, fontWeight: 600, color: "#E8E8EC" }}>Dernière relance · n° {last?.n}</span>
          <span style={{ fontSize: 10, fontWeight: 600, padding: "2px 7px", borderRadius: 999, background: unread ? "#3A1818" : "#16304D", color: unread ? "#F59A9A" : "#8CC4FF" }} data-testid={`row-relance-state-${task.id}`}>{unread ? "non lu" : "lu"}</span>
        </div>
        <div className="flex items-center" style={{ gap: 7, marginTop: 8 }}>
          <AvatarBlock initials={initialsOf(author)} size={22} seed={author.id || author.email} name={fullName(author) || undefined} />
          <span style={{ fontSize: 11.5, color: "#E8E8EC", fontWeight: 500 }}>{fullName(author) || "—"}</span>
          <span className="tabular-nums" style={{ fontSize: 10.5, color: "#8B8B93", marginLeft: "auto" }}>{fmtAlger(last?.created_at)}</span>
        </div>
        <div style={{ marginTop: 8, background: "#18181C", borderRadius: 8, padding: "7px 9px", fontSize: 11.5, lineHeight: 1.45, color: last?.message ? "#E8E8EC" : "#8B8B93", fontStyle: last?.message ? "normal" : "italic", overflowWrap: "anywhere" }} data-testid={`row-relance-message-${task.id}`}>
          {last?.message || "Sans message"}
        </div>
        <div className="flex items-center justify-between" style={{ marginTop: 9, fontSize: 10.5, color: "#8B8B93" }}>
          <span>{prev} relance{prev > 1 ? "s" : ""} précédente{prev > 1 ? "s" : ""}</span>
          <Link to={`/taches/${task.id}?scroll=chat`} onClick={(e) => e.stopPropagation()} style={{ color: "#3B9EFF", fontWeight: 500 }} data-testid={`row-relance-open-${task.id}`}>Voir dans la fiche ›</Link>
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}
